// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./cms_plugins/footer/scss/footer.scss
// module id = 205
// module chunks = 0